import { T } from "../../hooks/useTranslate";
import { useMixPanel } from "../../hooks/useMixPanel";

import { Box, Typography, Link } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import { CopyToClipboard } from "../CopyToClipboard";

import {
  iconSizingStyle,
  gridTextStyle,
  gridChildLeftWrapper,
} from "./drawer-styles";
import {
  formatPhoneNumber
} from "../../common/format-functions";


const ProfilePhoneLine = ({ customerHrefData, drawerType, eventLocation }) => {
  const { logEvent } = useMixPanel();
  let formattedPhoneNumber = "";

  if (customerHrefData?.homePhone) {
    formattedPhoneNumber = formatPhoneNumber(customerHrefData.homePhone);
  } else if (customerHrefData?.mobilePhone) {
    formattedPhoneNumber = formatPhoneNumber(customerHrefData.mobilePhone);
  }

  const handlePhoneNumberClick = () => {
    logEvent("phone_contact", {
      location: eventLocation,
      click_type: "phone_number_click",
      user_type: drawerType
    })
  }

  return (
    <>
      <Box sx={gridChildLeftWrapper}>
        <PhoneIcon sx={iconSizingStyle} />
      </Box>
      {formattedPhoneNumber !== "" ? (
        <Box component="span" sx={{ fontSize: "12px" }}>
          <Link
            data-testid={`${drawerType}-profile-phone`}
            href={`tel:${formattedPhoneNumber}`}
            onClick={handlePhoneNumberClick}
          >
            {formattedPhoneNumber}
          </Link>
          <CopyToClipboard
            stringToCopy={formattedPhoneNumber}
            iconId={`${drawerType}-profile-copy-phone`}
            data-testid={`${drawerType}-profile-copy-phone`}
            eventLocation={eventLocation}
            sendEvent={true}
            userType={drawerType}
          />
        </Box>
      ) : (
        <Typography sx={gridTextStyle} data-testid={`${drawerType}-profile-phone`}>
          <T>not_available</T>
        </Typography>
      )}
    </>
  )
}

export { ProfilePhoneLine }